import { useContext, useEffect, useRef } from 'react';

import { MobileHeaderCardContext } from './context';

export const useMobileHeaderCard = () => {
  const value = useContext(MobileHeaderCardContext);

  if (!value) {
    throw new Error(
      '`useMobileHeaderCard` should be used under `MobileHeaderCardContext`',
    );
  }

  return value;
};

export const usePreviousValue = <T>(
  value: T,
  onChange: (value: T, prevValue: T) => void,
) => {
  const valueRef = useRef<Nullable<T>>(null);

  useEffect(() => {
    if (value !== valueRef.current) {
      if (valueRef.current !== null) {
        onChange(value, valueRef.current);
      }
      valueRef.current = value;
    }
  }, [value]);
};
